const GQL_ASSESSMENT_OUTCOMES_DATA = `
query ClassroomAssessmentOutcomeData($input: ClassroomAssessmentOutcomeInput!) {
    classroomAssessmentOutcomeData(input: $input) {
        configsUsed {
            cutlineType
            cutlineLabel
            scoreType
            levels {
              label {
                labelEN
                labelES
              }
              value
              color
            }
        }
        graphData {
          period
          performanceScaleStats {
            label
            value
            count
          }
        }
    }
}
`;

export default GQL_ASSESSMENT_OUTCOMES_DATA;